var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        { staticClass: "d-flex flex-row" },
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("FormPageBlogPost", {
                attrs: {
                  data: _vm.blogPost,
                  blogCategories: _vm.blogCategories,
                  loading: _vm.isFormLoading,
                  disabled: _vm.isMutationLoading,
                  isNew: !_vm.id,
                  language: _vm.language,
                },
                on: {
                  submit: _vm.formBlogPostsSubmit,
                  "delete-blog-post": _vm.deleteBlogPost,
                  "language-update": function ($event) {
                    _vm.language = $event
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("ConfirmationDialog", {
        ref: "confirmBlogPostRemoving",
        attrs: { confirmText: "Удалить" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }